import { Box, theme } from '@bpba/ui-components';
import styled from 'styled-components';

export const PanelDivisor = styled(Box)({
  backgroundColor: theme.colors.secondary[2],
  padding: '24px',
  borderRadius: '4px',
});
